import { HtmlInput } from "../../html";
import { isNil, mergeProps } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export function HiddenAutocomplete({
  name,
  required,
  validationState,
  value,
  ...rest
}) {
  if (isNil(name)) {
    return null;
  }

  return /*#__PURE__*/_jsx(HtmlInput, { ...mergeProps(rest, {
      "aria-invalid": validationState === "invalid" ? true : undefined,
      "aria-required": required ? true : undefined,
      type: "hidden",
      value: value !== null && value !== void 0 ? value : ""
    })
  });
}